import { useEffect, useState } from "react";
import { large, medium, small } from "../theme/CSSPattern";

const useMediaQuery = (query: string): boolean => {
  const getMatches = (query: string): boolean => {
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState<boolean>(false);

  function handleChange() {
    setMatches(getMatches(query));
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query);
    handleChange();
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }
    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener("change", handleChange);
      }
    };
  }, [query]);

  return matches;
};

export const useDesktop = () => useMediaQuery(large());

export const useTablet = () => useMediaQuery(medium());

export const useMobile = () => useMediaQuery(small());

export default useMediaQuery;
